import Waitlist from "./Waitlist";
import Status from "./Status";

export default class UpcomingUserWaitlist {
    constructor(
        public readonly waitlist: Waitlist | null,
        public readonly status: Status,
    ) {}
}